import { Interceptors } from "../../shared/interceptors";
export const AuthService = {
  signIn(data) {
    let URI = `${process.env.REACT_APP_RBAC_BASE}/api/v1/internal-users/reset-password`;
    return Interceptors.requestInterceptors('PUT',URI,{ data});
  }
};
